import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IUserProjectFormByIdRouteProps extends PropsWithChildren {
    userProjectId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const UserProjectFormByIdRoute: FC<IUserProjectFormByIdRouteProps> = ({
    userProjectId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const userProjectIdToUse = (params.userProjectId ? +params.userProjectId : undefined) ?? userProjectId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={userProjectIdToUse}
            formDefinitionIdentifier={FormDefinitions.UserProject}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default UserProjectFormByIdRoute;
